var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 47,
    viewBox: "0 0 44 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0C9.77778 0 0 9.80805 0 22.0681V39.2322C0 41.1831 0.772617 43.0542 2.14788 44.4337C3.52315 45.8132 5.38841 46.5882 7.33333 46.5882H14.6667V26.9721H4.88889V22.0681C4.88889 17.5159 6.69166 13.1502 9.90062 9.93127C13.1096 6.71238 17.4619 4.90402 22 4.90402C26.5381 4.90402 30.8904 6.71238 34.0994 9.93127C37.3083 13.1502 39.1111 17.5159 39.1111 22.0681V26.9721H29.3333V46.5882H36.6667C38.6116 46.5882 40.4768 45.8132 41.8521 44.4337C43.2274 43.0542 44 41.1831 44 39.2322V22.0681C44 9.80805 34.1489 0 22 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.c85d86a0be2e93aaf346a95a3a1f3743.svg";
export { ForwardRef as ReactComponent };